// ✅ ResetPassword.jsx (Chakra 제거 + Ant Design 기반)
import { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthLayout from '@/components/common/layout/auth';
import AuthCard from '@common/auth-card.jsx';
import { Typography, Input, Button, Spin, Alert } from 'antd';
import { SwapLeftOutlined } from '@ant-design/icons';
import { t } from '@/utils/translator';
import api from '@/api/api';
import i18n from '@/i18n';

const { Title } = Typography;
function PasswordReset() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [message, setMessage] = useState('');

  const handleResetPassword = async () => {
    if (!email.trim()) {
      setStatus('error');
      setMessage(t('이메일을 입력해주세요'));
      return;
    }

    setLoading(true);
    setStatus(null);
    setMessage('');

    try {
      const response = await api.post('/users/reset-password', {
        user_email: email,
        lang: i18n.language
      });

      setStatus('success');
      setMessage(t('비밀번호 초기화 이메일이 발송되었습니다'));
    } catch (error) {
      setStatus('error');
      setMessage(
        error.response?.data?.message || 
        t('비밀번호 초기화 요청에 실패했습니다')
      );
    } finally {
      setLoading(false);
    }
  };

  // 성공 또는 실패 메시지 표시
  if (status) {
    return (
      <AuthLayout>
        <AuthCard>
          <div>
            <Title level={5} className="fw-medium mb-3">
              {t('비밀번호 찾기')}
            </Title>
            <div>
              <Alert
                message={message}
                type={status}
                showIcon
                className="mb-3"
              />
              <div>
                <Link to="/">
                  <SwapLeftOutlined className="me-1" />
                  {t('홈으로 돌아가기')}
                </Link>
              </div>
            </div>
          </div>
        </AuthCard>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <AuthCard>
        <div>
          <Title level={5} className="fw-medium mb-3">
            {t('비밀번호 찾기')}
          </Title>
          <div>
            <Input
              size="large"
              placeholder={t('이메일 (로그인 ID)')}
              className="mb-3"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />

            <Button
              className="text-center h-auto rounded-pill bg-dark text-white mb-3 p-2"
              style={{ fontSize: '17px' }}
              block
              onClick={handleResetPassword}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spin size="small" className="me-2" />
                  {t('요청중')}...
                </>
              ) : (
                t('비밀번호 초기화')
              )}
            </Button>
            <div>
              <Link to="/">
                <SwapLeftOutlined className="me-1" />
                {t('홈으로 돌아가기')}
              </Link>
            </div>
          </div>
        </div>
      </AuthCard>
    </AuthLayout>
  );
}

export default PasswordReset;
